import React from 'react'
import "./Footer.css"
function Footer() {
    return (
        <div className="footer">
            <div className="container footercontent">
                <p>Just a simple corona details app I made while learning React.</p><br/>
                <p>Used disease.sh API</p><br/>
                <p>Naresh Ban</p>
            </div>
            
        </div>
    )
}

export default Footer
